// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAGU7DvL_V1BBNcE5L-MsOpcZJw4URkxD8",
    authDomain: "healing-our-villages.firebaseapp.com",
    databaseURL: "https://healing-our-villages.firebaseio.com",
    projectId: "healing-our-villages",
    storageBucket: "healing-our-villages.appspot.com",
    messagingSenderId: "51653682994",
    appId: "1:51653682994:web:aecfb913d76cf7bbc2992b",
    measurementId: "G-CLMFLXGVJY"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
